import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { readAuthToken } from '@noor/api';
import { env, FIRST_PAGE } from '@noor/config';
import {
  businessListSearchSchema,
  businessQueries,
  businessSearchToFilter,
  isBusinessFilterActive,
  type BusinessListSearch,
} from '@/entities/business';
import { RestaurantBannersPage } from '@/pages/business';

export const Route = createFileRoute('/business/restaurant-banners')({
  staticData: { permission: 'business.banners.view' },
  beforeLoad: () => {
    if (!env.VITE_ENABLE_MSW && !readAuthToken()) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  validateSearch: businessListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ context, deps }) => {
    // Search/status filter the whole collection client-side (see the table).
    const prefetch = isBusinessFilterActive(deps)
      ? context.queryClient.prefetchQuery(businessQueries.restaurantBannerAll())
      : context.queryClient.prefetchQuery(
          businessQueries.restaurantBannerList(businessSearchToFilter(deps)),
        );
    void prefetch.catch(() => undefined);
  },
  component: RestaurantBannersRoute,
});

function RestaurantBannersRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  const onParamsChange = (next: Partial<BusinessListSearch>) => {
    const resetPage = !('page' in next) && search.page !== FIRST_PAGE;
    void navigate({
      search: (prev) => ({
        ...prev,
        ...next,
        ...(resetPage ? { page: FIRST_PAGE } : {}),
      }),
    });
  };

  return <RestaurantBannersPage params={search} onParamsChange={onParamsChange} />;
}
